<template>
  <div>
    <div class="loader" id="loader"></div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "LayoutDefault"
};
</script>
